<template>
    <div class="actionArea">
        <choose @chooseType="getType" v-show="activeStep!=2"/>
        <upload v-if="chooseType && activeStep==1" @loadFile="getFile" v-loading="loading" element-loading-text="拼命加载中..." element-loading-spinner="el-icon-loading">
            <template v-slot:icon>
                <i class="iconfont cardIcon" v-if="idcardFile==null">&#xe68d;</i>
                <img v-if="idcardFile!=null" :src="idcardBase64" class="previmg">
            </template>
            <template v-slot:tips>
                <div class="el-upload__text" v-html="frontTipsTxt"></div>
            </template>
        </upload>
        <upload v-if="!chooseType && activeStep==1" @loadFile="getFile" v-loading="loading" element-loading-text="拼命加载中..." element-loading-spinner="el-icon-loading">
            <template v-slot:icon>
                <i class="iconfont cardIcon" v-if="idcardFile==null">&#xe68e;</i>
                <img v-if="idcardFile!=null" :src="idcardBase64" class="previmg">
            </template>
            <template v-slot:tips>
                <div class="el-upload__text" v-html="backTipsTxt"></div>
            </template>
        </upload>
        <inputEdit v-if="activeStep==2" :chooseType="chooseType" :editData="editData"
                   v-loading="loading" element-loading-text="拼命加载中..." element-loading-spinner="el-icon-loading"/>
        <download v-if="activeStep==3" :previewUrl="[previewUrl]" :chooseType="chooseType" :recordId="recordId" :fileName="fileName" @clearImg="clearImg"
                  v-loading="loading" element-loading-text="拼命加载中..." element-loading-spinner="el-icon-loading" @changePreviewURL="changePreviewURL"/>
        <div class="actionButton">
            <button class="nextStepBtn" @click="preStep" v-if="activeStep==2">上一步</button>
            <button class="nextStepBtn" @click="nextStep" v-if="activeStep!=3">下一步</button>
        </div>
    </div>
</template>

<script>
    import choose from "../idcard/choose";
    import upload from "../idcard/upload";
    import inputEdit from "../idcard/inputEdit";
    import download from "../idcard/download";
    import {uploadIdcard, idcardEditInfo} from "../../api/idcard";
    import {getPreviewImg} from "../../api/license";
    import {baseHost,imgPreview} from "../../plugins/host";
    export default {
        name:"actionArea",
        components:{choose, upload, inputEdit, download},
        data(){
            return{
                loading:false,
                chooseType:true,
                activeStep:1,
                idcardFile:null,
                idcardBase64:"",
                frontTipsTxt:"将身份证正面照片拖到此处，或<em>点击上传",
                backTipsTxt:"将身份证反面照片拖到此处，或<em>点击上传",
                editData:[],
                previewUrl:"",
                fileName:"",
                recordId:""
            }
        },
        methods:{
            getFile(file){
                this.idcardFile = file;
                // 图片base64化
                var self = this;
                var reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = function (e) {
                    var newUrl = this.result;    //图片路径
                    self.idcardBase64 = newUrl;
                };
                if(this.chooseType){
                    this.frontTipsTxt = `<span style="display:inline-block;width: 16px;height: 16px; border: 1px solid green;border-radius: 50%;color: green;margin:20px 15px;font-size: 12px">√</span>${file.name}`;
                }else{
                    this.backTipsTxt = `<span style="display:inline-block;width: 16px;height: 16px; border: 1px solid green;border-radius: 50%;color: green;margin:20px 15px;font-size: 12px">√</span>${file.name}`;
                }
            },
            uploadFile(){
                var side = this.chooseType ? 'front' : 'back';
                if(this.idcardFile != null || this.idcardFile){
	                if(this.idcardFile.size > 1024*1024*3){
		                this.$message.error("图片大小不能超过3M！");
		                return false;
	                };
                    this.loading = true;
                    this.$axios(uploadIdcard(this.idcardFile,side))
                        .then(res=>{
                            if(res.data.code == 0){
                                this.loading = false;
                                this.editData = res.data.data;
                                // 存储localStrange中
                                localStorage.setItem(`id_card${this.editData.record_id}`, JSON.stringify(res.data.data))
                                this.$router.push(`/id_card?id=${this.editData.record_id}&step=${this.$store.state.stepNum}&side=${side}`);
                                this.$store.commit("changStepNum");
                            }
                        })
                        .catch(error=>{
                            this.loading = false
                        })
                }else {
                    this.$message.warning("请先上传身份证");
                }
            },
            nextStep(){
                if(this.activeStep == 1){
                    this.uploadFile();
                }
                if(this.activeStep == 2){
                    // 编辑
                    this.loading = true;
                    var side = this.chooseType ? 'front' : 'back';
                    this.$axios(idcardEditInfo(this.editData))
                        .then(res=>{
                            if(res.data.code === 0){
                                this.loading = false;
                                this.previewUrl = imgPreview() + '/license' + res.data.data.translation + '?t='+Math.random();
                                this.fileName = res.data.data.filename;     // 下载记录文件名
                                // 清除本地存储数据
                                localStorage.removeItem(`id_card${this.editData.record_id}`);
                                localStorage.setItem(`idcardEnData${this.editData.record_id}`, JSON.stringify(res.data.data.translation_data));
                                // 软跳转到 预览地址， 并修改vuex中的状态
                                this.recordId = this.editData.record_id;
                                this.$router.push(`/id_card?id=${this.editData.record_id}&step=${this.$store.state.stepNum}&side=${side}`);
                                this.$store.commit("changStepNum")
                            }
                        })
                        .catch(error=>{
                            this.loading = false;
                        })
                }
            },
            preStep(){
                this.$store.commit("changStepNumCut");
                window.location.href = baseHost() + '/id_card';
            },
            getType(data){
                this.chooseType = data;
                this.idcardBase64 = "";
                this.idcardFile = null;
                if(this.chooseType){
                    this.frontTipsTxt = "将身份证正面照片拖到此处，或<em>点击上传";
                }else{
                    this.frontTipsTxt = "将身份证反面照片拖到此处，或<em>点击上传";
                }
            },
            changePreviewURL(val){
                this.previewUrl = val[0] + '?t='+Math.random();
            },
            clearImg(val){
                this.idcardBase64 = "";
                this.chooseType = val;
            }
        },
        created() {
            // 当id=xx时，即在第三步  获取当前id的预览图 供下载
            if(this.$route.query.step){
                this.$store.commit("changStepNum", this.$route.query.step);
                // 当前订单id
                var Bid = this.$route.query.id;
                this.recordId = Bid;
                // 获取数据
                if(parseInt(this.$route.query.step) === 1){     // edit page
                    // 从本地获取编辑数据
                    if(localStorage.getItem(`id_card${Bid}`)){
                        // this.chooseType = this.$route.query.side;
                        this.chooseType = this.$route.query.side === 'front' ? true : false;
                        this.editData = JSON.parse(localStorage.getItem(`id_card${Bid}`));
                    }else {
                        // localStorage is false, jump preview page, now edited
                        window.location.href = `/id_card?id=${Bid}&step=${this.$store.state.stepNum}`
                    }
                }
                if(parseInt(this.$route.query.step) === 2){ // preview page
                    this.activeStep = 3;
                    this.chooseType = this.$route.query.side === 'front' ? true : false;
                    this.editData = JSON.parse(localStorage.getItem(`id_card${Bid}`));
                    // 从接口获取预览数据
                    this.$axios(getPreviewImg(Bid, 'idcard',this.$route.query.side))
                        .then(res=>{
                            if(res.data.code == 0){
                                this.previewUrl = imgPreview() + '/license' + res.data.data.translation;
                                this.fileName = res.data.data.filename;     // save fileName,use download
                            }
                        })
                }
            }
        },
        computed:{
            getStoreStep(){
                return this.$store.state.stepNum;
            }
        },
        watch:{
            getStoreStep(newval,oldval){
                this.activeStep = newval;
            }
        }
    }
</script>

<style>
    .actionArea{
        width: 1000px;
        height: 650px;
        background: #fff;
        margin-top: 20px;
    }
    .actionButton{
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 50px;
    }
    .nextStepBtn{
        color: #d82a22;
        border: solid 1px #d82a22;
        padding: 5px 30px;
        margin-right: 50px;
    }
    .previmg{
        max-width: 500px;
    }
    .el-loading-spinner i{
        color: #8590A6;
        font-size: 32px;
    }
    .el-loading-spinner .el-loading-text{
        color: #8590A6;
    }
</style>
